/*  eslint-env browser */
import * as React from 'react';
import { createPortal } from 'react-dom';
import { canUseDOM } from '../../../dom';
import { useLayoutEffect } from '../../../hooks/useLayoutEffect';
import LayersContext from './LayersContext';
function Layer(_ref) {
  var _ref$host = _ref.host,
    hostProp = _ref$host === void 0 ? 'overlays' : _ref$host,
    _ref$container = _ref.container,
    container = _ref$container === void 0 ? true : _ref$container,
    children = _ref.children;
  // const hostRef = React.useRef(null);
  var containerRef = React.useRef(null);
  var context = React.useContext(LayersContext);
  var host = (context === null || context === void 0 ? void 0 : context[hostProp]) || (canUseDOM ? document.body : null);

  // The container element is created lazily once.
  function getContainer() {
    if (!container) return host;
    if (containerRef.current === null) {
      // $FlowFixMe[incompatible-use] hostRef can't be null, canUseDOM check
      containerRef.current = host.ownerDocument.createElement('div');
    }
    return containerRef.current;
  }
  useLayoutEffect(function () {
    if (containerRef.current) {
      // $FlowFixMe[incompatible-use] hostRef can't be null, useLayoutEffect don't run on the server
      host.appendChild(containerRef.current);
    }
    return function () {
      if (containerRef.current) {
        // $FlowFixMe[incompatible-use] hostRef can't be null, useLayoutEffect don't run on the server
        host.removeChild(containerRef.current);
      }
    };
  }, [host]);
  if (!canUseDOM) {
    return null;
  }

  // $FlowFixMe[incompatible-call] we should have a body at that point, but still try to clean this later.
  return /*#__PURE__*/createPortal(children, getContainer());
}
export default Layer;